import React from "react";
import { PlusOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import ManageCouponModal from "components/Modals/ManageCouponModal";

/**
 *
 * @param { Function} oldData for Coupon modal
 * @param { Function} reload for Coupon modal
 * @param { Function} setVisible for Coupon modal
 * @param { Object} data for Coupon modal
 * @param { Object } buttonStyle
 * @returns button with modal
 */

export default function App(props) {
  const { setVisible, buttonStyle, oldData, children } = props;

  const showModal = () => {
    setVisible(true);
  };

  return (
    <>
      <Button
        shape="round"
        color={colors.blue}
        onClick={showModal}
        style={buttonStyle && buttonStyle}
      >
        {children ? (
          children
        ) : (
          <>
            {oldData ? (
              "به روز رسانی"
            ) : (
              <span>
                <PlusOutlined style={{ marginLeft: 8 }} />
                کد تخفیف جدید
              </span>
            )}
          </>
        )}
      </Button>
      <ManageCouponModal {...props} />
    </>
  );
}
